import {
  GetEnvValue,
  GetSingleCookie,
  GetConfirmation,
  isClient,
  RecordOrderChannel,
} from "./Tools";
import { typeofObject, typeofString } from "../Utils";
import configAuth from "../../configuration/configAuth.json";

let globalAjax = [];
export const AjaxOptions = {
  type: "GET",
  dataType: "json",
  cache: true,
};

export function AjaxOptionsHeaders(WD, cb) {
  AjaxOptionsHeadersCookies(WD, (UserId, Token) => {
    cb({
      UID: UserId,
      Token: Token,
      NDFingerPrint: isClient ? (window.black_box || (window._fmOpt && window._fmOpt.getinfo ? window._fmOpt.getinfo() || '' : '')) : "",
    }); //NDFingerPrint: _dealSmDeviceId,
  });
}

export function AjaxOptionsHeadersCookies(params, callback) {
  let relCookieID = null;
  let relCookieToken = null;

  if (!params.cookie) {
    // NO Cookie Callback Ghost
    return callback(relCookieID, relCookieToken);
  }

  if (GetSingleCookie(params.cookie, "Token")) {
    relCookieToken = GetSingleCookie(params.cookie, "Token");
  }

  if (GetSingleCookie(params.cookie, "UID")) {
    relCookieID = GetSingleCookie(params.cookie, "UID");
  }

  // NO match Callback Ghost
  return callback(relCookieID, relCookieToken);
}

export function AJAX(params, callback) {
  RecordOrderChannel();
  let _AuthList = configAuth.url,
    _PathName = window.location.pathname,
    _Token = GetSingleCookie(window.document.cookie, "Token");

  /**
   * No Token
   */
  let Black = false; // True Match False No PDP NO
  _AuthList.map((data, index) => {
    if (_PathName.match(new RegExp(data))) {
      Black = true;
    }
  });
  let options = {};
  if (!params) {
    callback({ status: 1, message: "error total params Url" });
    return;
  }
  // OBJECT_ASSIGN
  Object.assign(options, AjaxOptions);

  // URL
  options.url = "https://" + GetEnvValue(process.title, "api") + params.url;

  // DATA
  options.data =
    params.processData === false ? params.data : JSON.stringify(params.data);

  // METHOD
  if (params.type) options.type = params.type;

  // DATA_TYPE
  if (params.dataType) options.method = params.dataType;

  // HEADERS
  if (!params["headers"]) params["headers"] = {};

  // CONTENT_TYPE
  options.contentType =
    params.contentType === false ? false : "application/json; charset=utf-8";

  // processData
  options.processData = params.processData === false ? false : true;

  // AJAX Abort
  if (params.abort) options.abort = params.abort;

  // AJAX Post Cookie
  options.xhrFields = { withCredentials: true };

  //console.log('getOrderStatus', "FETCH")

  // Get Headers UID Token
  AjaxOptionsHeaders(window.document, (cbHeader) => {
    //console.log('getOrderStatus', "GETHEADER")

    options["headers"] = Object.assign({}, params.headers || {}, cbHeader);

    if (!options.headers.UID) delete options.headers.UID;
    if (!options.headers.Token) delete options.headers.Token;
    
    // IE(11) Not supported Fetch
    if ($ && $.ajax) {
      jQueryAjax(options, (ajaxCallback) => {
        callback(ajaxCallback);
      });
    }
  });
}

export function jQueryFormat(responseText) {
  const jQueryFormatWrap = [
    "jQueryStatus",
    "results",
    "status",
    "errorCode",
    "errorMessage",
    "dataResult" //为了返回错误信息
  ];
  // let deepCopyResponse = $.extend( true, responseText )
  for (let i in responseText) {
    if (jQueryFormatWrap.indexOf(i) < 0) {
      delete responseText[i];
    }
  }
  return responseText;
}

export function outJson(object) {
  if (typeofString(object)) {
    return JSON.parse(object);
  }
  return object;
}

// ajax - abort + responseCatch
export function jQueryAjax(jQueryOptions, jQueryCallback) {
  if (jQueryOptions["abort"]) {
    if (globalAjax[jQueryOptions["abort"]])
      globalAjax[jQueryOptions["abort"]].abort();
    globalAjax[jQueryOptions["abort"]] = $.ajax(
      Object.assign({}, jQueryOptions, {
        success: function (json) {
          json.jQueryStatus = {};
          // json.jQueryStatus.status = tmpAjax.status;
          json.jQueryStatus.status = globalAjax[jQueryOptions["abort"]].status;
          json.ajaxOptions = jQueryOptions;
          jQueryCallback(GetConfirmation(jQueryFormat(json)));
        },
        error: function (err) {
          let json = typeofObject(err.responseText)
            ? JSON.parse(err.responseText)
            : { errResponseText: err.responseText || "" };
          json.jQueryStatus = {};
          // json.jQueryStatus.status = tmpAjax.status;
          json.jQueryStatus.status = globalAjax[jQueryOptions["abort"]].status;
          json.ajaxOptions = jQueryOptions;
          jQueryCallback(GetConfirmation(jQueryFormat(json)));
        },
      })
    );
  } else {
    let tmpAjax = null;
    tmpAjax = $.ajax(
      Object.assign({}, jQueryOptions, {
        success: function (json) {
          json.jQueryStatus = {};
          // json.jQueryStatus.status = tmpAjax.status;
          json.jQueryStatus.status = tmpAjax.status;
          json.ajaxOptions = jQueryOptions;
          jQueryCallback(GetConfirmation(jQueryFormat(json)));
        },
        error: function (err) {
          let json = typeofObject(err.responseText)
            ? JSON.parse(err.responseText)
            : { errResponseText: err.responseText || "" }; //这段逻辑有点看不懂，暂时先不动
          json.jQueryStatus = {};
          // json.jQueryStatus.status = tmpAjax.status;
          json.jQueryStatus.status =
            tmpAjax && tmpAjax.status ? tmpAjax.status : null;
          json.ajaxOptions = jQueryOptions;
          json.dataResult = typeofString(err.responseText) && JSON.parse(err.responseText) //这段为了返回错误信息
          jQueryCallback(GetConfirmation(jQueryFormat(json)));
        },
      })
    );
  }
}

export function fetchAjax(params) {
  return "IE 6 - 11 NO supported Fetch";
}



// WEBPACK FOOTER //
// ./common/lib/Fetch.js